import { Box, Stack, Typography } from '@mui/material'

import { SaveTemplateButton } from '@salsita-ai/platform-project-sdk/configurator'
import { usePresetEmbeddedState } from '@salsita-ai/platform-project-sdk/react'

import { configuratorInterface } from '../../systems/configurator-interface'
import { AddToCartButton } from './AddToCartButton'
import { AddToWishlistButton } from './AddToWishlistButton'

export const customSidebarFooterElement = configuratorInterface.createCustomPhoenixLayoutElement(
  'CustomSidebarFooter',
  () => {
    const formattedPrice = configuratorInterface.useRootEntityPrice()
    const showSaveTemplateButton = !!usePresetEmbeddedState()

    return (
      <Box sx={{ padding: 2 }} component="div">
        {showSaveTemplateButton ? (
          <Stack alignItems="center">
            <SaveTemplateButton />
          </Stack>
        ) : (
          <Stack direction="row" justifyContent="space-between" alignItems="center">
            {formattedPrice != null && (
              <Stack>
                <Typography variant="body2" color="text.secondary">
                  Total price
                </Typography>
                <Typography variant="h5" fontWeight="bold">
                  {formattedPrice}
                </Typography>
              </Stack>
            )}
            <Stack direction="row" spacing={2} alignItems="center">
              <AddToWishlistButton />
              <AddToCartButton />
            </Stack>
          </Stack>
        )}
      </Box>
    )
  }
)
